import React from 'react';
import '../styles/DashboardPreview.css';

const DashboardPreview = () => {
    return (
        <div className="section dashboard-section" id="dashboard-preview">
            <div className="container">
                <h2 className="section-title">Real-time Dashboard</h2>
                <p className="dashboard-desc">
                    실시간 센서 데이터 모니터링 · MQTT 기반 원격제어 · IoT PLC 관리
                </p>
                <div className="dashboard-mockup">
                    <div className="dashboard-tile tile-large">
                        <div className="tile-header">Power Consumption</div>
                        <div className="tile-content chart-placeholder">
                            <div className="chart-line"></div>
                        </div>
                    </div>
                    <div className="dashboard-tile">
                        <div className="tile-header">Temperature</div>
                        <div className="tile-value">24.5°C</div>
                    </div>
                    <div className="dashboard-tile">
                        <div className="tile-header">Humidity</div>
                        <div className="tile-value">45%</div>
                    </div>
                    <div className="dashboard-tile">
                        <div className="tile-header">Status</div>
                        <div className="tile-value status-active">Active</div>
                    </div>
                    <div className="dashboard-tile">
                        <div className="tile-header">Devices</div>
                        <div className="tile-value">12</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardPreview;
